import config from '@/config';
import BaseIconMixin from '@/components/icons/mixins/BaseIcon';

const SwitchMixin = {
  mixins: [
    BaseIconMixin,
  ],
  computed: {
    isSwitchOn() {
      const vars = this.getVarsByActorsRole(config.ICOOL.ACTORS_ROLES.SWITCH);
      if (vars.length > 0) {
        return vars[0].value;
      }
      return false;
    },
  },
};

export default SwitchMixin;
